interface IconProps {
  className?: string;
}

export function ContractIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 4v4H4m11 0h4V4m0 11v4h-4m-6 0H4v-4"
      />
    </svg>
  );
}
